/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Saving_RecordingInputs */

const en_audio_recorder_saving_recording = /** @type {(inputs: Audio_Recorder_Saving_RecordingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving Recording`)
};

const fr_audio_recorder_saving_recording = /** @type {(inputs: Audio_Recorder_Saving_RecordingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement en cours`)
};

const de_audio_recorder_saving_recording = /** @type {(inputs: Audio_Recorder_Saving_RecordingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufnahme speichern`)
};

const it_audio_recorder_saving_recording = /** @type {(inputs: Audio_Recorder_Saving_RecordingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvataggio della registrazione`)
};

const ru_audio_recorder_saving_recording = /** @type {(inputs: Audio_Recorder_Saving_RecordingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранение записи`)
};

const es_audio_recorder_saving_recording = /** @type {(inputs: Audio_Recorder_Saving_RecordingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardando grabación`)
};

const zh_cn2_audio_recorder_saving_recording = /** @type {(inputs: Audio_Recorder_Saving_RecordingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存录音`)
};

const ja_audio_recorder_saving_recording = /** @type {(inputs: Audio_Recorder_Saving_RecordingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`録音の保存`)
};

const hi_audio_recorder_saving_recording = /** @type {(inputs: Audio_Recorder_Saving_RecordingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिकॉर्डिंग सहेजी जा रही है`)
};

const pt_pt2_audio_recorder_saving_recording = /** @type {(inputs: Audio_Recorder_Saving_RecordingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gravação de salvamento`)
};

/**
* | output |
* | --- |
* | "Saving Recording" |
*
* @param {Audio_Recorder_Saving_RecordingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_saving_recording = /** @type {((inputs?: Audio_Recorder_Saving_RecordingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Saving_RecordingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_saving_recording(inputs)
	if (locale === "de") return de_audio_recorder_saving_recording(inputs)
	if (locale === "it") return it_audio_recorder_saving_recording(inputs)
	if (locale === "ru") return ru_audio_recorder_saving_recording(inputs)
	if (locale === "es") return es_audio_recorder_saving_recording(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_saving_recording(inputs)
	if (locale === "ja") return ja_audio_recorder_saving_recording(inputs)
	if (locale === "hi") return hi_audio_recorder_saving_recording(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_saving_recording(inputs)
	return en_audio_recorder_saving_recording(inputs)
});